import React from "react";
import "./BackendSkills.css";
import { FaAdn, FaPhp, FaPython, FaLaravel, FaWordpress } from "react-icons/fa";
import { DiCodeigniter, DiMysql } from "react-icons/di";
import { SiDjango } from "react-icons/si";
const BackendSkills = () => {
  return (
    <div className="container">
      <div className="parent">
        <div className="item2">
          <div>
            <FaPhp />
          </div>
        </div>
        <div className="item2">
          <div>
            <FaPython />
          </div>
        </div>
        <div className="item2">
          <div>
            <SiDjango />
          </div>
        </div>
        <div className="item2">
          <div>
            <DiCodeigniter />
          </div>
        </div>
        <div className="item2">
          <div>
            <FaLaravel />
          </div>
        </div>
        <div className="item2">
          <div>
            <DiMysql />
          </div>
        </div>
        <div className="item2">
          <div>
            <FaWordpress />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackendSkills;
